import { render, staticRenderFns } from "./AgeTechServiceDetail.vue?vue&type=template&id=83f6497c"
import script from "./AgeTechServiceDetail.vue?vue&type=script&lang=js"
export * from "./AgeTechServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./AgeTechServiceDetail.vue?vue&type=style&index=0&id=83f6497c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports